<div class="email-in-bio-changes-container">
  <div class="header-section">
    <h3>Email in Bio Changes</h3>
    <div class="date-selector">
      <label for="date-input">Select Date:</label>
      <input 
        type="date" 
        id="date-input" 
        [(ngModel)]="selectedDate" 
        (change)="onDateChange()"
        class="date-input">
    </div>
  </div>

  <div *ngIf="loading" class="loading-message">
    Loading email in bio changes...
  </div>

  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <div *ngIf="!loading && !selectedDate && !errorMessage" class="no-data-message">
    Please select a date to view email in bio changes
  </div>

  <div *ngIf="!loading && selectedDate && emailInBioChanges.length === 0 && !errorMessage" class="no-data-message">
    No email in bio changes found for {{ selectedDate }}
  </div>

  <div *ngIf="!loading && emailInBioChanges.length > 0" class="change-tiles">
    <div class="change-tile" *ngFor="let change of emailInBioChanges"
         (click)="openTikTokProfile(change.handle)" title="Open TikTok profile">
      <div class="tile-top">
        <span class="tile-handle">{{ change.handle }}</span>
        <span class="tile-date">{{ change.dateChanged }}</span>
      </div>
      <span class="genre-pill" [ngClass]="genreColorClass(getGenreString(change.genre))">{{ getGenreString(change.genre) }}</span>
      <div class="tile-emails">
        <div class="email-row old">
          <span class="email-label">Old</span>
          <span class="email-value">{{ change.oldEmail || '—' }}</span>
        </div>
        <div class="email-row new">
          <span class="email-label">New</span>
          <span class="email-value">{{ change.newEmail || '—' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
